<mat-form-field
  appearance="outline"
  [floatLabel]="floatLabel"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [formControl]="control"
    [placeholder]="placeholder"
    [min]="min"
    [max]="max"
    [disabled]="isDisabled"
  />
  <mat-datepicker-toggle
    matIconSuffix
    [for]="picker"
  ></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-error>
    <ng-content select="[error]"></ng-content>
  </mat-error>
</mat-form-field>
